import { Link } from "react-router-dom";
import { Linkedin, Mail, MapPin } from "lucide-react";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-primary text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="md:col-span-2">
            <Link to="/" className="inline-block mb-4">
              <span className="font-serif font-bold text-2xl text-white">
                Saloni Shah
              </span>
            </Link>
            <p className="text-white/70 leading-relaxed max-w-md mb-6">
              Helping companies safely ship SaMD & AI-enabled digital products
              in regulated markets. Expert in AI governance, FDA compliance, and
              MedTech regulations.
            </p>
            <div className="flex gap-4">
              <a
                href="https://www.linkedin.com/in/saloni-s-246823188"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center transition-colors duration-300"
                aria-label="LinkedIn"
                data-testid="footer-linkedin"
              >
                <Linkedin size={18} />
              </a>
              <a
                href="mailto:shahsaloni2912@gmail.com"
                className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center transition-colors duration-300"
                aria-label="Email"
                data-testid="footer-email"
              >
                <Mail size={18} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/"
                  className="text-white/70 hover:text-white transition-colors duration-300"
                  data-testid="footer-link-home"
                >
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-white/70 hover:text-white transition-colors duration-300"
                  data-testid="footer-link-about"
                >
                  About
                </Link>
              </li>
              <li>
                <Link
                  to="/blog"
                  className="text-white/70 hover:text-white transition-colors duration-300"
                  data-testid="footer-link-blog"
                >
                  Insights
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Contact</h3>
            <ul className="space-y-3">
              <li className="flex items-center gap-2 text-white/70">
                <MapPin size={16} />
                <span>Bothell, WA</span>
              </li>
              <li>
                <a
                  href="mailto:shahsaloni2912@gmail.com"
                  className="flex items-center gap-2 text-white/70 hover:text-white transition-colors duration-300"
                >
                  <Mail size={16} />
                  <span>shahsaloni2912@gmail.com</span>
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-white/10 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white/50 text-sm">
            © {currentYear} Saloni Shah. All rights reserved.
          </p>
          <p className="text-white/50 text-sm">
            AI Governance • SaMD Regulations • MedTech Compliance
          </p>
        </div>
      </div>
    </footer>
  );
}
